import { ChangeEvent, FC, FormEvent, useState } from 'react';
import { Button, DialogContent, DialogTitle, Stack, TextField, Typography } from '@mui/material';
import { QRCodeSVG } from 'qrcode.react';

import { confirmDialog, ConfirmDialogType } from '/common/ConfirmDialog';

import { RecoveryCodes } from '../RecoveryCodes/RecoveryCodes';

import { StyledDialog } from './styles';

const QR_SIZE = 300;
const OTP_LENGTH = 6;

export interface IUseQRCodeParams {
  url: string;
  recoveryCodes: string[];
  onSubmit: (code: string) => void;
  onClear: () => void;
}

export const QRCode: FC<IUseQRCodeParams> = ({ url, recoveryCodes, onClear, onSubmit }) => {
  const [code, setCode] = useState('');

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setCode(e.target.value);
  };

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onSubmit(code);
  };

  const onClose = () => {
    onClear();
    setCode('');
  };

  const QRNode = (
    <>
      <DialogTitle sx={{ p: 0 }}>Setting MFA</DialogTitle>
      <DialogContent>
        <form onSubmit={handleSubmit}>
          <Typography>Scan QR Code with Google Authenticator</Typography>
          <QRCodeSVG value={url} size={QR_SIZE} />
          <Typography>Type code from Google Authenticator</Typography>
          <Stack direction='row' alignItems='center' gap={2}>
            <TextField size='small' autoFocus={true} value={code} onChange={handleChange} />
            <Button disabled={code.length < OTP_LENGTH} size='large' type='submit'>
              Submit
            </Button>
          </Stack>
        </form>
      </DialogContent>
    </>
  );

  const handleClose = () => {
    if (recoveryCodes.length > 0) {
      confirmDialog({
        type: ConfirmDialogType.Warning,
        title: 'CLOSE RECOVERY CODES',
        content: 'Please make sure you saved recovery codes. It is the only way to login if you lose MFA device.',
        onSuccess: onClose,
      });
    } else {
      onClose();
    }
  };

  return (
    <StyledDialog open={!!url} size={QR_SIZE} onClose={handleClose}>
      {recoveryCodes.length === 0 && QRNode}
      {recoveryCodes.length > 0 && <RecoveryCodes codes={recoveryCodes} />}
    </StyledDialog>
  );
};
